import { tap, map, concatMap } from "rxjs/operators";
import { ApiResponse } from "@core/models/api-response.model";
import { Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Pagination } from "@core/models/pagination.model";
import { DefaultDataService, HttpUrlGenerator } from "@ngrx/data";
import { Injectable } from "@angular/core";
import { MemberReport } from "@core/models/member-report-model";

@Injectable()
export class MemberReportDataService extends DefaultDataService<MemberReport> {
  messages$ = new Subject<any[]>();
  pagination: Pagination;

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super("MemberReport", http, httpUrlGenerator, { root: "" });
  }

  getWithQuery(pageParam: string): Observable<any[]> {
    return this.http.get<ApiResponse>(`/report/memberreport${pageParam}`).pipe(
      tap((res) => this.paginationInit(res)),
      map((res) => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if (res) {
      return (this.pagination = res.data.paginations);
    }
  }

  exportReport(pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportmemberreport${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }
}
